import script from "./terminal-strategy-card.vue?vue&type=script&lang=tsx&setup=true"
export * from "./terminal-strategy-card.vue?vue&type=script&lang=tsx&setup=true"

import "./terminal-strategy-card.vue?vue&type=style&index=0&id=a48dec06&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a48dec06"]])

export default __exports__